import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirmation-reason-dialog',
  templateUrl: './confirmation-reason-dialog.component.html',
  styleUrls: ['./confirmation-reason-dialog.component.scss']
})
export class ConfirmationReasonDialogComponent implements OnInit {
  cancelButtonText:any;
  message:any;
  confirmButtonText:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationReasonDialogComponent>
  ) { }

  ngOnInit() {
  }
  onConfirmClick(){

  }

}
